import { accessFormPopupActions } from '@common-reducers/AccessFormPopupReducer';
import { contactsLabelsSelectOneObjectByQuery, labelSelectOneObjectByQuery } from "@common-reducers/DBServiceThunks";
import { useAppDispatch, useAppSelector } from '@common-reducers/hooks/store.hook';
import { toggleChatLabelThunk } from '@common-reducers/labels-reducer/labels-thunks';
import { selectUserObject } from '@common-reducers/UserSelectors';
import { AlertCircle, CheckCircle } from 'lucide-react';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '@/components/ui/tooltip';
import { memo } from 'react';
import { useTranslation } from 'react-i18next';
import { namespace } from "@common-config/constants";


type Props = {
    index?: number
    btId?: string
    waChatId: string
    size?: number
}

export default memo(function NeedAttentionButton({ index, waChatId, size }: Props) {
    const { t } = useTranslation(namespace);
    const dispatch = useAppDispatch()
    const authUser = useAppSelector(selectUserObject);

    const label = useAppSelector(state => labelSelectOneObjectByQuery(state.DBLabelReducer, {
        name: 'needs attention'
    }))

    const contactLabel = useAppSelector((state) => contactsLabelsSelectOneObjectByQuery(state.DBContactsLabelsReducer, {
        labelId: label?._id,
        waChatId
    }))

    const openIssueContact = (e: React.MouseEvent) => {
        e.preventDefault();
        e.stopPropagation();
        dispatch(toggleChatLabelThunk({
            labelId: label?._id || '',
            waChatId: waChatId
        }))
    }

    return (
        <TooltipProvider>
            <Tooltip>
                <TooltipTrigger asChild>
                    <button
                        key={`${index}-${waChatId}`}
                        onClick={openIssueContact}
                        className={`group p-1 rounded transition-colors cursor-pointer ${contactLabel ? "text-red-500 hover:text-green-500" : "text-gray-500 hover:text-red-500"}`}
                    >
                         {contactLabel ? (
                            <>
                                <AlertCircle size={size || 18} className="currentColor group-hover:hidden" />
                                <CheckCircle size={size || 18} className="currentColor hidden group-hover:block" strokeWidth={2} />
                            </>
                         ) : (
                             <AlertCircle size={size || 18} className="currentColor" strokeWidth={2} />
                         )}
                    </button>
                </TooltipTrigger>
                <TooltipContent side="bottom">
                    <p>{contactLabel
                        ? t('labels.done', { defaultValue: 'Done' })
                        : t('labels.needsAttention', { defaultValue: 'Needs Attention' })}
                    </p>
                </TooltipContent>
            </Tooltip>
        </TooltipProvider>
    )
})
